<template>
    <component :is="view" v-on:abbort="$emit('abbort')" v-on:stepdone="$emit('stepdone', '2')"> </component>
</template>

<script>

    import Problemform from '../views/ProblemForm'
    import Shippingtracker from '../views/ShippingTracker'
    import Whitedraw from '../views/Whitedraw'

    export default {
        name: "secondstep",

        components: {
            Problemform,
            Shippingtracker,
            Whitedraw
        },

        computed: {
            view () {

                let reason = this.$store.getters.getReason

                switch ( reason ){

                    case 'defect':
                    case 'incomplete':
                    case 'notcorrect':
                        return 'problemform'

                    case 'revocation':
                        return 'whitedraw'

                    case 'notrecieved':
                        return 'shippingtracker'

                    case 'other':
                        this.$emit('stepdone', '2')
                }
            }
        }

    }
</script>

<style scoped>

</style>